/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimeOffContext} from '../api'

 export const useQueryGetTimeOffContext = createReactQueryHook('getTimeOffContext', getTimeOffContext)
